import { signDetached } from '@exodus/crypto/curve25519'
import assert from 'minimalistic-assert'

const TAG = Buffer.from('MX')

export const signMessage = async ({ privateKey, message }) => {
  assert(
    Buffer.isBuffer(privateKey) || privateKey instanceof Uint8Array,
    `privateKey must be Uint8Array or Buffer`
  )
  assert(
    Buffer.isBuffer(message?.rawMessage) || message?.rawMessage instanceof Uint8Array,
    `rawMessage must be Uint8Array or Buffer`
  )

  /**
   * We add the tag to the signature here, to ensure that the signature
   * will only be valid for a message and not any other type of object
   * like transactions, etc.
   */
  const signData = Buffer.concat([TAG, message.rawMessage])
  return signDetached({ message: signData, privateKey, format: 'buffer' })
}
